export default "__VITE_ASSET__CLhNoLyY__"